var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_907_84978)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35868 3H5.76237V8.61824C5.76237 9.94313 4.82139 11.0482 3.57129 11.3017V14.3984H11.1538V15.5127H3.57129V16.9726H11.1538V18.0869H3.57129V21H11.154L11.154 8.99188L9.35868 3ZM12.4178 8.98599L12.4177 21H20V18.0869H12.418V16.9726H20V15.5127H12.418V14.3984H20V11.3016C18.7502 11.0479 17.8096 9.9429 17.8096 8.61824V3H14.2113L12.4178 8.98599Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_907_84978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVest);
export default __webpack_public_path__ + "static/media/icon-vest.98648a207f7d7182597f621d31d2b99c.svg";
export { ForwardRef as ReactComponent };